import { useTranslate } from '~/shared/context/use-translate';
import type { JobArchitectureSelectLabels } from '~/ui/domain/job-architecture-select/JobArchitectureSelect';

export const useArchitectureSelectLabels = (): JobArchitectureSelectLabels => {
    const translate = useTranslate();

    return {
        all: translate('pages.job-architecture-v2.select-architecture.all'),
        current: translate('pages.job-architecture-v2.select-architecture.current'),
        empty: translate('pages.job-architecture-v2.search-modal.no-results-title'),
        search: translate('common.search'),
    };
};
